import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { IncrementFor } from 'frontend-utils';
import GeneralButtonsButtonExpandArrow from 'lumen/components/general/buttons/button-expand-arrow';

interface SettingsMappingHierarchyCategoryItemBenchmarkSignature {
  Args: {
    category: unknown;
  };
}

export default class SettingsMappingHierarchyCategoryItemBenchmark extends Component<SettingsMappingHierarchyCategoryItemBenchmarkSignature> {
  @service('benchmark-insight/beni-service')
  declare benchmarkInsightBeniService: Services['benchmark-insight/beni-service'];
  @service declare errorTracking: Services['error-tracking'];
  @service declare intl: Services['intl'];

  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, ember/no-tracked-properties-from-args
  @tracked categoryName = this.args.category.name;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get displayName() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return this.args.category.getDisplayName(this.intl, this.errorTracking);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isFiltering() {
    if (this.benchmarkInsightBeniService.segmentFilter) {
      return (
        // @ts-expect-error: Incorrect type
        this.args.category.id === this.benchmarkInsightBeniService.segmentFilter
      );
    }
    return false;
  }

  @action
  onClickCategoryItem(): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    this.benchmarkInsightBeniService.setSegmentFilter(this.args.category.id);
  }

  @action
  onToggleItemExpansion(): void {
    // @ts-expect-error: Incorrect type
    this.args.category.isExpanded = !this.args.category.isExpanded;
  }

  <template>
    {{! @glint-nocheck }}
    <div
      class="category-item
        {{if @category.isTopLevelCategory 'category-item--top-level'}}
        {{if this.isFiltering 'category-item__filtering'}}
        "
    >
      <IncrementFor @times={{@category.depth}}>
        <span class="category-item__spacer"></span>
      </IncrementFor>
      {{#if @category.isExpandable}}
        <button
          class="button--unstyled"
          type="button"
          {{on "click" this.onToggleItemExpansion}}
        >
          <GeneralButtonsButtonExpandArrow
            @isExpanded={{@category.isExpanded}}
          />
        </button>
        <button
          class="category-item__name-container button--unstyled"
          type="button"
          {{on "click" this.onClickCategoryItem}}
        >
          <div class="category-item__name flex items-center gap-100 truncate">
            {{this.displayName}}
          </div>
        </button>
      {{else}}
        <button
          class="category-item__name-container button--unstyled"
          type="button"
          {{on "click" this.onClickCategoryItem}}
        >
          <div class="category-item__name truncate">{{this.displayName}}</div>
        </button>
      {{/if}}
    </div>
  </template>
}
